<script setup>
// assets/project/src/views/ToExpert/CriterionLine.vue
import StarsComponent from "@/components/Base/StarsComponent.vue";
import {defineProps, toRefs, ref, computed, watch, defineEmits, onMounted} from "vue";
import {Tooltip} from "ant-design-vue";

const stars = ref(0);
let isLoading = ref(true);

onMounted(() => {
	stars.value = criterion_vote.value
	if (stars.value === null) {
		stars.value = 0
	}
	isLoading.value = false;
})

const props = defineProps({
	criterion_vote: {
		required: true
	},
	criterion_comment: {
		required: true
	},
	criterion: {},
	criterion_index: {}
});
const {criterion_vote, criterion_comment} = toRefs(props);

const pointsText = computed(() => {
	const num = stars.value % 100;
	if (num >= 11 && num <= 19) {
		return 'баллов';
	}
	const i = num % 10;
	switch (i) {
		case (1):
			return 'балл';
		case 2:
		case 3:
		case 4:
			return 'балла';
		default:
			return 'баллов';
	}
});

const emit = defineEmits(['update:criterion_vote', 'update:criterion_comment', 'onChange'])


watch(() => stars.value, (newValue) => {
	emit('update:criterion_vote', newValue);
	emit('onChange', newValue);
})


</script>


<template>
	<div class="score_header__wrapper">
		<div class="columns score_header">
			<div class="column score_header_left">
				<div v-if="!isLoading" class="your_score_text" style="display:block;">
					<template v-if="criterion.hint">
						<span class="your_score_text_inner">{{ criterion.name }}</span>
						<Tooltip :title="criterion.hint" :overlayStyle="{ maxWidth: '600px', minWidth: 'auto', whiteSpace: 'pre-wrap' }" :overlayInnerStyle="{ padding: '10px' }"><span class="question-icon">?</span></Tooltip>
					</template>
					<template v-else>
						<span class="your_score_text_inner">{{ criterion.name }}</span>
					</template>
					<template v-if="criterion.customAnswers && criterion.customAnswers.length > 0">
					</template>
					<template v-else>
						<div style="margin-top: 10px;">
							<StarsComponent v-model="stars" :max-stars="criterion.gradingScale || 10" />
						</div>
						
					</template>
				</div>
				<div v-if="criterion.description" class="criterion-description">
					{{ criterion.description }}
				</div>
			</div>
			<div class="column is-narrow score_header_right">
				<div>
					<template v-if="criterion.customAnswers && criterion.customAnswers.length > 0">
						<template v-for="(answer, index) in criterion.customAnswers" :key="index">
							<div class="radio-wrapper"><input type="radio" :id="criterion_index+''+index"
							                                  :checked="criterion_vote === answer.name" :value="answer.name"
							                                  @click="emit('update:criterion_vote', $event.target.value === criterion_vote ? null : $event.target.value)"
							                                  @change="emit('update:criterion_vote', $event.target.value); emit('onChange', $event.target.value)">
								<label :for="criterion_index+''+index">{{ answer.name }}</label></div>
						</template>
					</template>
					<template v-else>
						<span class="score_header_right_text">{{ stars }} {{ pointsText }} из {{ criterion.gradingScale || 10 }}</span>
					</template>
				</div>
			</div>
		
		</div>
		<div class="score_cooment_textarea">
				<textarea
					v-model="criterion_comment"
					@change="emit('update:criterion_comment', $event.target.value)"
					placeholder="Ваш комментарий"
				></textarea>
		</div>
	</div>

</template>


<style lang="scss" scoped>
label {
	cursor: pointer;
}
.question-icon {
	display: inline-flex;
	justify-content: center;
	align-items: center;
	width: 18px;
	height: 18px;
	border-radius: 50%;
	background-color: #e0e0e0;
	color: #555;
	font-size: 12px;
	font-weight: bold;
	margin-left: 8px;
	cursor: help;
}

.criterion-description {
	font-size: 14px;
	color: #666;
	margin-top: 10px;
	font-style: italic;
}

</style>